import { run } from "../../utils/common.ts";
import {
  IMAGE_RESOURCE_TYPE,
  VIDEO_RESOURCE_TYPE,
} from "../../views/Board/constants.ts";
import type { ResourceType } from "../../views/Board/types.ts";
import { DEFAULT_IMAGE_SIZE } from "../../views/constants.ts";
import { BaseImage } from "./BaseImage.tsx";
import { BaseSizedContainer } from "./BaseSizedContainer.tsx";
import { BaseVideo } from "./BaseVideo.tsx";

export const ContentContainer = ({
  resourceType,
  width = DEFAULT_IMAGE_SIZE,
  height = DEFAULT_IMAGE_SIZE,
  contentClassName,
  onLoad,
  src,
  overridingComponent,
  loading = "eager",
  allowGrow = false,
}: {
  resourceType: ResourceType;
  width?: number;
  height?: number;
  src?: string | null;
  contentClassName?: string;
  onLoad?: () => void;
  loading?: "eager" | "lazy";
  overridingComponent?: React.ReactNode;
  allowGrow?: boolean;
}) => (
  <BaseSizedContainer
    width={width}
    height={height}
    overridingCompponent={overridingComponent}
    allowGrow={allowGrow}
  >
    {run(() => {
      switch (resourceType) {
        case IMAGE_RESOURCE_TYPE:
          return (
            <BaseImage
              className="w-full h-full"
              imageClassName={contentClassName}
              onLoad={onLoad}
              loading={loading}
              src={src}
            />
          );
        case VIDEO_RESOURCE_TYPE:
          return (
            <BaseVideo
              className="w-full h-full"
              videoClassName={contentClassName}
              onLoad={onLoad}
              src={src}
            />
          );
      }
    })}
  </BaseSizedContainer>
);
